const name = "Simple Create";
const bytecode =
  "0xef00010100040200010011030001003204000000008000046000600060006000ec0061201560015500ef000101000402000100060300010014040000000080000260006000ee00ef00010100040200010001040000000080000000";

const simpleCreate = { name, bytecode };

export default simpleCreate;
